import { CURRENT_PRODUCT_MODE } from '@utils/constants';

export enum AXIS_NAME {
  WAIT_TIME = 'Wait Time',
  CIR_TIME_PRECEDING_EXIT = 'CIR Time preceding Exit',
  AD_PLAYING_TIME = 'Ad Playing Time',
  PLAYING_TIME = 'Playing Time',
  PLAYS = 'Plays',
  LifeDropFrameRatio = 'Dropped Frames Ratio',
}

export enum ENGAGEMENT {
  LifeRebufferingRatio = 'LifeRebufferingRatio',
  LifeNetworkRebufferingRatio = 'LifeNetworkRebufferingRatio',
  LifeAvgBitrateKbps = 'LifeAvgBitrateKbps',
  LifeAverageAvgBitrateKbps = 'LifeAverageAvgBitrateKbps',
  LifeAvgFramesPerSec = 'LifeAvgFramesPerSec',
  LifeSessionTimeSecs = 'LifeSessionTimeSecs',
  LifeJoinTimeSecs = 'LifeJoinTimeSecs',
  LifeVideoRestartTimeSecs = 'LifeVideoRestartTimeSecs',
  LifePlayingTimeMins = 'LifePlayingTimeMins',
  LifeCompletionPct = 'LifeCompletionPct',
  LifeNetworkRebufferingEvents = 'LifeNetworkRebufferingEvents',
  LifePodTimebeforePrerollExitSecs = 'LifePodTimebeforePrerollExitSecs',
  LifeVideoRestartTimeMs = 'LifeVideoRestartTimeMs',
  LifePlayingTimeMs = 'LifePlayingTimeMs',
  LifeSessionTimeMs = 'LifeSessionTimeMs',
  LifeJoinTimeMs = 'LifeJoinTimeMs',
  LifePausedTimePct = 'LifePausedTimePct',
  LifePausedTimeSecs = 'LifePausedTimeSecs',
  LifeAvgNumBitrateSwitches = 'LifeNumBitrateSwitches',
  JoinedAverageBitrate = 'JoinedAvgBitrateKbps',
  LifeEBVSWaitTimeMs = 'LifeEBVSWaitTimeMs',
  LifeVPFPlayingTimeMs = 'LifeVPFPlayingTimeMs',
  LifeVPFTPlayingTimeMs = 'LifeVPFTPlayingTimeMs',
  LifeVPFBPlayingTimeMs = 'LifeVPFBPlayingTimeMs',
  LifeVSFWaitTimeMs = 'LifeVSFWaitTimeMs',
  LifeVSFTWaitTimeMs = 'LifeVSFTWaitTimeMs',
  LifeVSFBWaitTimeMs = 'LifeVSFBWaitTimeMs',
  LifeExitRelatedCIRTimeMs = 'LifeExitRelatedCIRTimeMs',
  LifeDropFrameEndedPlays = 'LifeDropFrameEndedPlays',
}

export enum DISTRIBUTION {
  IntervalRebufferingTimeSecs = 'IntervalRebufferingTimeSecs',
  IntervalNetworkRebufferingTimeSecs = 'IntervalNetworkRebufferingTimeSecs',
  IntervalAvgBitrateKbps = 'IntervalAvgBitrateKbps',
  IntervalAverageAvgBitrateKbps = 'IntervalAverageAvgBitrateKbps',
  IntervalAvgFramesPerSec = 'IntervalAvgFramesPerSec',
  IntervalVideoRestartTimeSecs = 'IntervalVideoRestartTimeSecs',
  AverageLifePlayingTimeMins = 'AverageLifePlayingTimeMins',
  PlaysWithValidJoinTime = 'PlaysWithValidJoinTime',
  MinutesPlayed = 'MinutesPlayed',
}

export const MSDimension = [
  'IntervalRebufferingTimeSecs',
  'IntervalNetworkRebufferingTimeSecs',
  'LifeSessionTimeSecs',
  'IntervalVideoRestartTimeSecs',
  'LifeJoinTimeSecs',
  'LifeVideoRestartTimeSecs',
  'LifePlaytimeSecs',
];

export const MinsDimension = [ENGAGEMENT.LifePlayingTimeMins] as string[];

const _METRIC_MAPPING_DURATION = {
  EI: {},
  AI: {},
  APP: {},
  ODP: {},
  ECO_SERVER: {},
};

export const METRICS_MAPPING_DURATION = _METRIC_MAPPING_DURATION[CURRENT_PRODUCT_MODE];

const _METRIC_MAPPING_ENGAGEMENT = {
  EI: {},
  AI: {},
  APP: {},
  ODP: {},
  ECO_SERVER: {},
};

export const METRICS_MAPPING_ENGAGEMENT = _METRIC_MAPPING_ENGAGEMENT[CURRENT_PRODUCT_MODE];
